<div class="text-center">
    <span class="material-icons" style="font-size: 48px; color: #666;">info</span>
    <p style="font-size: 16px; color: #666;">Attualmente non ci sono dati disponibili.</p>
</div>